import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import {BmIBViewModel} from '../../../../models/bm/bm-ib.viewmodel'
import {DateTimeHelper} from '../../../../utils/DateTimeHelper.util'
import {ActivityStatus} from '../../../../common/enums'
import {IBMMeetingDetailViewModel} from '../../../../models/bm/bm-meeting-detail.viewmodel'
import {namespace} from 'vuex-class'
import {BM_MODULE_NAMESPACE} from '../../../../store/building-monitor/bm-types.store'
const BMStore = namespace(BM_MODULE_NAMESPACE)

@Component
class BMIBItem extends Vue {
  @BMStore.Getter bmMeeting: { activityStatus: ActivityStatus, data: IBMMeetingDetailViewModel }

  isItemActive: boolean
  ActionModal: {
    PlanAdd: string,
    PlanUp: string,
    PlanSelect: string,
    MemberAdd: string,
    MemberUp: string,
    ContractorAdd: string,
    ContractorUp: string,
    IBAdd: string,
    IBUp: string,
    CommentAdd: string,
    CommentUp: string,
    NoAction: string
  }

  constructor () {
    super()
    this.isItemActive = false
    this.ActionModal = {
      PlanAdd: 'PLAN_ADD',
      PlanUp: 'PLAN_UP',
      PlanSelect: 'PLAN_SELECT',
      MemberAdd: 'MEMBER_ADD',
      MemberUp: 'MEMBER_UP',
      ContractorAdd: 'CONTRACTOR_ADD',
      ContractorUp: 'CONTRACTOR_UP',
      IBAdd: 'IB_ADD',
      IBUp: 'IB_UP',
      CommentAdd: 'COMMENT_ADD',
      CommentUp: 'COMMENT_UP',
      NoAction: 'NO_ACTION'
    }
  }
  @Prop({ default: {}, type: [Object] })
  ib: BmIBViewModel;
  @Prop({ default: [], type: [Array] })
  comments: any[];
  @Prop({ default: false, type: [Boolean] })
  dtIsLoading: boolean;
  @Prop({ default: false, type: [Boolean] })
  disableActions: boolean;

  mounted () {}

  get lblSetting () {
    return {
      ...require('@/locales/generic-labels').default,
      ...require('@/locales/building-monitor').default,
      ...require('@/locales/reception').default,
      ...require('@/locales/ticket').default
    }
  }

  get displayActions (): boolean {
    return !this.disableActions
  }

  get inspection () {
    if (this.ib.id === this.bmMeeting.data.generalComments.id) { return this.bmMeeting.data.generalComments }
    return this.bmMeeting.data.inspections.find(x => x.id === this.ib.id)
  }

  getDateDuration (creation: string) {
    return DateTimeHelper.parseDateTimeCalendar(creation)
  }

  openBaseModal (action: string, data: any = null) {
    if (action === this.ActionModal.CommentUp) {
      data.ibId = this.ib.id
    }
    this.$emit('openBaseModal', action, data)
  }

  deleteIB () {
    this.$emit('openDeleteIB', this.ib)
  }

  displayModalDeleteImage (file, cmt) {
    file.ibId = this.ib.id
    file.cmtId = cmt.id
    this.$emit('openDeleteImageComment', file)
  }
  getStateTicketColor (item) {
    switch (item.ticket.state) {
      case 'open':
      case 'reopen':
        return 'green'
      case 'in_progress':
        return 'orange'
      case 'close':
        return 'red'
      default:
        return 'primaryLight'
    }
  }
  goToTicket (item) {
    this.$router.push('/ticket/' + item.id + '/channel/' + item.channel)
  }

  typeDocument (name) {
    let a = name.split('.')
    return a[a.length - 1]
  }

  nameFileDoc (name) {
    let s = name
    let n = s.lastIndexOf('.')
    s = s.substring(0, n !== -1 ? n : s.length)
    return s
  }

  acronym (value: any) {
    if (!value) return
    const {firstname, lastname} = value
    if (!lastname && !firstname) return ''
    if (!lastname) return firstname.slice(0, 2)
    else if (!firstname) return lastname.slice(0, 2)
    return `${firstname[0]}${lastname[0]}`
  }

  progressTxt (contractor) {
    if (contractor.progress && contractor.progress !== '0%') { return this.$t(this.lblSetting.bmProgressIc) + ': ' + contractor.progress }
    return null
  }

  startDateTxt (contractor) {
    if (!contractor.date_start_work) return this.$t(this.lblSetting.bmNoDateIc)
    return this.$t(this.lblSetting.bmStartIc) + ' ' + DateTimeHelper.parseDateTimeCalendarUTC(contractor.date_start_work)
  }

  endDateTxt (contractor) {
    if (!contractor.date_start_work) return this.$t(this.lblSetting.bmNoDateIc)
    return this.$t(this.lblSetting.bmEndIc) + ' ' + DateTimeHelper.parseDateTimeCalendarUTC(contractor.date_end_work)
  }

  getTicketRef (item) {
    return '#' + this.getPbType(item.pb_type) + item.ticket_number
  }

  getPbType (pbType) {
    switch (pbType) {
      case 'public':
        return 'S'
      case 'private':
        return 'G'
      case 'internal':
        return 'I'
    }
  }
}

export default BMIBItem



// WEBPACK FOOTER //
// ./src/containers/building-monitor/components/bm-ib-item/index.ts